// Stripe link
export const STRIPE_LINK_TEXT =
    "Manage payment information on our secure billing page";

// Vat form
export const VAT_PLACEHOLDER =
    "If added (optional), this will appear on your invoices. Some people need this for tax or business reasons and include Tax ID, VAT, job number, etc.";
export const DEFAULT_VAT_ERROR_MESSAGE = "Failed to Save";
